import { useNavigate } from 'react-router-dom';
import { LandingPage } from './v32/components/LandingPage';
import { useModal } from './v32/components/ModalProvider';
import { DOMAIN_CONFIG } from './config/env';

/**
 * Wrapper component for the landing page that provides Wasp routing integration
 * This component can be used as a Wasp page component
 */
export function LandingPageWrapper() {
  const navigate = useNavigate();
  const { openModal } = useModal();

  const handleGetStarted = () => {
    // In production, this would redirect to go.trynura.app
    // In development, just navigate to signup
    const isProduction = process.env.NODE_ENV === 'production';
    
    if (isProduction) {
      // Production: redirect to app subdomain
      window.location.href = `https://${DOMAIN_CONFIG.APP_SUBDOMAIN}/signup`;
    } else {
      // Development: navigate within same app
      navigate('/signup');
    }
  };

  const handleSeeHowItWorks = () => {
    openModal('howItWorks');
  };

  return (
    <LandingPage 
      onGetStarted={handleGetStarted}
      onSeeHowItWorks={handleSeeHowItWorks}
    />
  );
}